export enum ReportFilterValueEnum {
  DEPARTMENT = 'departmentId',
  PROJECT = 'projectId',
  BUDGET_CHAPTER = 'budgetChapterId',
  JOURNAL = 'journalId',
  ACCOUNT = 'accountId',
  DATE = 'date',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo'
}
